import { ConfirmDialog } from '@westhetics/ui'
import { useContext, type ReactNode } from 'react'
import { Link } from 'react-router'
import { joinList } from './labels'
import { LeaveContext } from './use-unsaved-guard'

/** O link da migalha: com alteração não salva, pergunta antes de sair. */
export function GuardedLink({
  to,
  className,
  children,
}: {
  to: string
  className?: string
  children: ReactNode
}) {
  const leave = useContext(LeaveContext)
  return (
    <Link
      to={to}
      className={className}
      onClick={(event) => {
        if (!leave) return
        event.preventDefault()
        leave(to)
      }}
    >
      {children}
    </Link>
  )
}

/** "Sair sem salvar?": diz em que blocos estão as alterações que se perdem. */
export function UnsavedDialog({
  open,
  blocks,
  kept,
  onStay,
  onLeave,
}: {
  open: boolean
  /** Os blocos com alteração: "Endereço", "Contato". */
  blocks: string[]
  /** O que não se perde: "O que já foi salvo continua." */
  kept: string
  onStay: () => void
  onLeave: () => void
}) {
  const where =
    blocks.length === 0
      ? 'As alterações desta tela se perdem.'
      : `As alterações em ${joinList(blocks)} se perdem.`
  return (
    <ConfirmDialog
      open={open}
      onOpenChange={(next) => {
        if (!next) onStay()
      }}
      tone="primary"
      title="Sair sem salvar?"
      effect={`${where} ${kept}`}
      cancelLabel="Continuar editando"
      confirmLabel="Sair sem salvar"
      onConfirm={onLeave}
    />
  )
}
